import { useRef, useState, useEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

const useResizeObserver = (): [
  React.RefObject<HTMLDivElement>,
  ResizeObserverEntry | undefined,
] => {
  const ref = useRef<HTMLDivElement>(null);
  const [entry, setEntry] = useState<ResizeObserverEntry | undefined>(
    undefined
  );

  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      setEntry(entries[0]);
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return [ref, entry];
};

export default useResizeObserver;
